import React from "react";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";

export const SiteLayout = ({ children }) => (
  <div style={{ minHeight: "100vh", background: "#f2f5f8", color: "#0c1a2e" }}>
    <Navigation />
    <main>{children}</main>
    <Footer />
    <CookieBanner />
  </div>
);
